<style lang="scss">
    .yuan{
        width:12px;height: 12px;border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
    }

</style>

<template>
    <div class="search-wrap searchb2c">
        <aside class='search-btn'>
            <ButtonGroup>
                <Button v-for="(item,index) in btnsearch" :key="index" :type="changestatus===item.value&&changekeys===item.type?'primary':'default'" @click="handleBtn(item.type,item.value)">{{item.label}}</Button>
            </ButtonGroup>
        </aside>
        <article class="search-main clearfix">
            <div class="pull-right">
                <Form inline>
                    <Button type="primary" @click="update(true)" icon="ios-search">{{$t("global.common.btn_search",{defaultValue:'查询'})}}</Button>
                    <Button @click="resetdata" icon='md-refresh'>{{$t("global.common.btn_reset",{defaultValue:'重置'})}}</Button>
                    <Button type="dashed" @click="isOpen=!isOpen">{{$t("global.common.btn_more",{defaultValue:'更多查询'})}}<Icon type="ios-arrow-down" class="margin-left-5"></Icon></Button>
                </Form>
            </div>
            <div class="pull-right">
                <Form :label-width="80" inline>
                    <FormItem :label="$t('global.common.line',{defaultValue:'项目'})" >
                        <Select v-model="formData.IN_lineId" filterable clearable multiple :max-tag-count="2">
                            <Option v-html="item.label" v-for="item in productTarget" :value="item.value" :key="item.value">{{item.label}}</Option>
                        </Select>
                    </FormItem>
                     <FormItem label='ERPSKU'>
                        <erpSkuInput v-bind:value="formData.CN_erpSku" :showread="'showyes'" @on-data="handleErpSku"></erpSkuInput>
                        <!-- <vInput v-model="formData.CN_erpSku"></vInput> -->
                    </FormItem>
                     <FormItem :label="$t('erp.product.category',{defaultValue:'品类'})">
                        <vSelect v-model="formData.EQ_categoryCode" filterable clearable>
                            <vOption v-for="item in categoryList" :value="item.value" :key="item.value">{{ item.label}}</vOption>
                        </vSelect>
                    </FormItem>
                </Form>
            </div>
        </article>
        <transition name='slide-both' >
            <div v-show="isOpen">
                <Form class="search-other" :label-width="110" inline >

                    <FormItem :label="$t('erp.product.pruchas_status',{defaultValue:'补货状态'})" style="width:330px;">
                        <Select filterable clearable v-model="formData.EQ_status" >
                            <Option v-for="item in replenList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('erp.product.product_status',{defaultValue:'产品状态'})" style="width:330px;">
                        <Select v-model="formData.EQ_enable" filterable clearable>
                            <Option v-for="item in isUsed" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('erp.product.category_name',{defaultValue:'品名'})" style="width:330px;">
                        <Input clearable v-model="formData.CN_name" ></Input>
                    </FormItem>

                    <FormItem :label="$t('erp.product.is_seasonal',{defaultValue:'是否季节性'})" style="width:330px;">
                        <Select v-model="formData.EQ_isSeasonal" filterable clearable>
                            <Option v-for="item in isSeasonal" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>

                    <FormItem :label="$t('erp.product.product_type',{defaultValue:'产品类型'})" style="width:330px;">
                        <Select v-model="formData.EQ_productType" filterable clearable>
                            <Option v-for="item in peoductsType" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>

                    <FormItem :label="$t('erp.product.repack_ornot',{defaultValue:'运输包装方式'})" style="width:330px;">
                        <Select v-model="formData.EQ_packingType" filterable clearable>
                            <Option v-for="item in packingTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>

                    <FormItem :label="$t('erp.product.signature',{defaultValue:'签收服务'})" style="width:330px;">
                        <Select v-model="formData.EQ_isSignService" filterable clearable>
                            <Option v-for="item in isSeasonal" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>

                    <FormItem :label="$t('erp.product.express_valuation',{defaultValue:'快递保价'})" style="width:330px;">
                        <Select v-model="formData.EQ_isInsurance" filterable clearable>
                            <Option v-for="item in isInsuranceList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>

                    <FormItem :label="$t('global.common.update_time',{defaultValue:'更新时间'})" style="width:330px;">
                        <DatePicker type="daterange"
                                    placement="bottom-end"
                                    placeholder="Select date"
                                    style="width:220px;"
                                    ref="amazonTime"
                                    :value="getdate"
                                    @on-change="handleChange"
                        ></DatePicker>
                    </FormItem>
                    <FormItem :label="$t('erp.product.saleslocation',{defaultValue:'销售定位'})" style="width:330px;">
                        <Select v-model="formData.IN_saleLocation" filterable clearable multiple>
                            <Option v-for="item in saleLocationList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('erp.product.label',{defaultValue:'标签'})" style="width:330px;">
                        <Select v-model="formData.IN_productLabel" filterable clearable multiple>
                            <Option v-for="item in iconList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('erp.product.allow_distribution',{defaultValue:'是否允许分销'})" style="width:330px;">
                        <Select v-model="formData.EQ_isDistribution" filterable clearable>
                            <Option v-for="item in isDistributionList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="UPC" style="width:330px;">
                        <Input clearable v-model="formData.EQ_upc" ></Input>
                    </FormItem>
                    <FormItem :label="$t('erp.product.out_box_shape', { defaultValue: '单品包装形状' })" style="width:330px;">
                        <Select v-model="formData.EQ_shapeType" clearable>
                            <Option v-for="item in shapeTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('erp.product.out_box_material', { defaultValue: '单品包装材质' })" style="width:330px;">
                        <Select v-model="formData.EQ_materialType" clearable>
                            <Option v-for="item in materialTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('erp.product.ismagnetic', { defaultValue: '是否带磁' })" style="width:330px;">
                        <Select v-model="formData.EQ_isMagnetism" clearable>
                            <Option v-for="item in isSeasonal" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('erp.product.isliquid', { defaultValue: '是否含液体' })" style="width:330px;">
                        <Select v-model="formData.EQ_isLiquid" clearable>
                            <Option v-for="item in isSeasonal" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('erp.product.isbattery', { defaultValue: '是否含电池' })" style="width:330px;">
                        <Select v-model="formData.EQ_isContainBattery" clearable>
                            <Option v-for="item in isSeasonal" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('erp.product.isfragile', { defaultValue: '是否易碎' })" style="width:330px;">
                        <Select v-model="formData.EQ_isFragile" clearable>
                            <Option v-for="item in isSeasonal" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <!-- <FormItem label="关键字" style="width:330px;">
                        <Input clearable v-model="formData.EQ_keyword" ></Input>
                    </FormItem> -->
                    <FormItem :label="$t('erp.setting.goodsstatus', { defaultValue: '产品状况' })" style="width: 330px;">
                        <Input v-model="formData.CN_productMidCondition" clearable />
                    </FormItem>
                </Form>
            </div>
        </transition>
        <transition>
            <Form inline class="search-other" v-if="changekeys!='LE_latestShipDate'">
                <Button class="margin-right-5 dark-primary" @click="handleModal('add')">{{$t('global.common.add',{defaultValue:'添加'})}}</Button>

                <Dropdown @on-click="handleModal">
                    <Button class="margin-right-5" type="success">
                        {{$t('global.common.import',{defaultValue:'导入'})}}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem name="importBase">{{$t('erp.product.import_base',{defaultValue:'导入基本信息'})}}</DropdownItem>
                        <DropdownItem name="importWarehouse">{{$t('erp.product.import_warehouse',{defaultValue:'导入仓库发货信息'})}}</DropdownItem>
                        <DropdownItem name="importHead">{{$t('erp.product.import_head',{defaultValue:'导入头程信息'})}}</DropdownItem>
                        <!-- <DropdownItem name="importBuy">{{$t('erp.product.import_buy',{defaultValue:'导入采购信息'})}}</DropdownItem> -->
                        <DropdownItem name="importClear">{{$t('erp.product.import_qingguan', { defaultValue: '导入清关信息' })}}</DropdownItem>
                        <DropdownItem name="importAll">{{$t('erp.product.import_other', { defaultValue: '导入其他信息' })}}</DropdownItem>
                        <DropdownItem name="importFob">{{$t('erp.product.import_fob', { defaultValue: '导入Fob信息' })}}</DropdownItem>
                        <DropdownItem name="importStorage">{{$t('erp.product.import_storage', { defaultValue: '仓储客户导入专用' })}}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>

                <!-- <Button type="info" class="margin-right-5" @click="exportXlsx">查询条件导出</Button> -->
                <Dropdown @on-click="handleModal" v-if="productSet">
                    <Button class="margin-right-5" type="warning">
                        {{$t('erp.product.export_search',{defaultValue:'查询条件导出'})}}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem @click.native="exportXlsx(1)">{{$t('erp.product.export_base',{defaultValue:'导出基本信息'})}}</DropdownItem>
                        <DropdownItem @click.native="exportXlsx(2)">{{$t('erp.product.export_warehouse',{defaultValue:'导出仓库发货信息'})}}</DropdownItem>
                        <DropdownItem @click.native="exportXlsx(3)">{{$t('erp.product.export_head',{defaultValue:'导出头程信息'})}}</DropdownItem>
                        <!-- <DropdownItem @click.native="exportXlsx(4)">{{$t('erp.product.export_buy',{defaultValue:'导出采购信息'})}}</DropdownItem> -->
                        <DropdownItem @click.native="exportXlsx(5)">{{$t('erp.product.export_clear',{defaultValue:'导出清关信息'})}}</DropdownItem>
                        <DropdownItem @click.native="exportXlsx(7)">{{$t('erp.product.export_fob', { defaultValue: '导出Fob信息' })}}</DropdownItem>
                        <DropdownItem @click.native="exportXlsx(8)">{{$t('erp.product.export_other', { defaultValue: '导出其他信息' })}}</DropdownItem>
                        <DropdownItem @click.native="exportXlsx(6)">{{$t('erp.product.export_all',{defaultValue:'导出全部信息'})}}</DropdownItem>
                        <DropdownItem @click.native="exportXlsx(9)">{{$t('erp.product.export_storage',{defaultValue:'导出仓储客户模板'})}}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>

                <Dropdown trigger="click" v-if="productSet">
                    <Button class="margin-right-5 middle-content">
                        {{$t('erp.product.batch_addcancel',{defaultValue:'批量增加/取消标签'})}}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list" class="padding-left-10 padding-right-10 margin-top-10">

                        <Select v-model="itemids" filterable clearable multiple>
                            <Option v-for="item in iconList" :value="item.value" :key="item.value"><span class="yuan" :class="item.labelColour"></span>{{item.label}}</Option>
                        </Select>
                        <div class="text-center margin-top-10 margin-bottom-10">
                            <Button type="primary" class="margin-right-5" @click.native="handleModal('addcoloricon',itemids)">{{$t('erp.product.add_label',{defaultValue:'增加标签'})}}</Button>
                            <Button @click.native="handleModal('deletecoloricon',itemids)">{{$t('erp.product.cancel_label',{defaultValue:'取消标签'})}}</Button>
                        </div>
                    </DropdownMenu>
                </Dropdown>
                
                <Button type="info" v-if="pushHouseInfo" class="margin-right-5" @click="handleModal('pushwarehouse')">{{$t('erp.b2c.pushyuncang',{defaultValue:'推送仓库'})}}</Button>
                <Button type="info" v-if="productSet" class="margin-right-5" @click="handleModal('replenishment')">{{$t('erp.product.batch_replenishment',{defaultValue:'批量修改补货状态'})}}</Button>
                <Button type="default" v-if="productCancel" class="margin-right-5" @click="handleModal('disabled')">{{$t('erp.product.batch_inactive',{defaultValue:'批量停用'})}}</Button>

            </Form>
        </transition>
    </div>
</template>
<script>
    // 多语言 this.$i18n.t('product.list.all')
    import { HttpGetIconList, HttpAddIcons, HttpGetCategories } from '@/service/products/allproducts'
    import erpSkuInput from '@components/templates/erpskuinput.vue';
    import { mapState,mapGetters} from "vuex";

    export default {
        components: {
            erpSkuInput
        },
        data() {
            return {
                changestatus:'',
                changekeys:'EQ_enable',
                isOpen: false,
                getdate:[],
                formData:{
                    IN_lineId:'',
                    CN_erpSku:'',
                    EQ_categoryCode:'',
                    EQ_status:'',
                    EQ_enable:'',
                    CN_name:'',
                    EQ_isSeasonal:'',
                    EQ_productType:'',
                    IN_saleLocation:'',
                    IN_productLabel:'',
                    EQ_isDistribution:'',
                    EQ_upc:'',
                    EQ_keyword: '',
                    EQ_shapeType: '',
                    EQ_materialType: '',
                    EQ_isMagnetism: '',
                    EQ_isLiquid: '',
                    EQ_isContainBattery: '',
                    EQ_isFragile: '',
                    GE_updatedAt:'',
                    LE_updatedAt:''
                },
                allisAddition:'',

                // 后端需要给的标签形式
                iconList:[],
                categoryList:[],
                itemids:[],
                saleLocationList: [
                    {value: 0,label:this.$t('erp.product.none', { defaultValue: '无' })},
                    {value: 1,label:'NEW'},
                    {value: 2,label:'Core'},
                    {value: 3,label:'Normal'},
                    {value: 5,label:'Discontinued-w/ Inventory'},
                    {value: 6,label:'Discontinued-w/o Inventory'},
                ],
                isDistributionList:[
                    {value: 1,label:this.$t('erp.global.yes',{defaultValue:'是'})},
                    {value: 0,label:this.$t('erp.global.no',{defaultValue:'否'})},
                ]
            };
        },
        created() {
            // 请求品类的下拉
            this.getcategory()
            this.update();
            this.pushHouseInfo = this.handleAuth('erp.product.push_house');
            
            this.productSet = this.handleAuth('erp.product.set');
            this.productCancel = this.handleAuth('erp.product.cancel');
            
        },
        mounted(){
            this.bus.$on("changelang", val=>{
                setTimeout(()=>{
                    this.update(true);
                },600)
            });
        },
        computed: {
            ...mapGetters('diction',['getNewDifferentAllProductList']),
            productTarget() {
                return this.getNewDifferentAllProductList.map((item) => {
                    const bool= item.attach.flag === 3;
                    return {
                        label: bool?`<span style='text-decoration:line-through'>${item.label}</span>`:`${item.label}`,
                        value: item.value,
                    }
                }) 
            },
            btnsearch() {
                return [
                    { value: '', type: 'EQ_enable', label: this.$t("global.common.all", { defaultValue: '全部' }) },
                    { value: 1, type: 'EQ_enable', label: this.$tc("global.common.active", 1, { defaultValue: '可用产品' }) },
                    { value: 0, type: 'EQ_enable', label: this.$tc("global.common.inactive", 1, { defaultValue: '停用产品' }) },
                ]
            },
            replenList() {
                return [
                    { value: '0', label: this.$t("erp.product.replenishment", { defaultValue: '正常补货' }) },
                    { value: '1', label: this.$t("erp.product.no_replenishment", { defaultValue: '不再补货' }) },
                ]
            },
            // 是否停用
            isUsed() {
                return [
                    { value: '0', label: this.$tc("global.common.inactive", 2, { defaultValue: '停用' }) },
                    { value: '1', label: this.$tc("global.common.active", 2, { defaultValue: '可用' }) },
                ]
            },
            // 是否季节性
            isSeasonal() {
                return [
                    { value: '1', label: this.$t("erp.global.yes", { defaultValue: '是' }) },
                    { value: '0', label: this.$t("erp.global.no", { defaultValue: '否' }) },
                ]
            },
            // 产品类型
            peoductsType() {
                return [
                    { value: '1', label: this.$t("erp.product.finish_goods", { defaultValue: '成品' }) },
                    { value: '2', label: this.$t("erp.product.accessories", { defaultValue: '配件' }) },
                    { value: '3', label: this.$t("erp.product.consumables", { defaultValue: '耗材' }) },
                ]
            },
            packingTypeList(){
                return [
                    { value: 'REPACK', label: 'REPACK' },
                    { value: 'ORIGINAL', label: 'ORIGINAL' },
                ]
            },
            isInsuranceList(){
                return [
                    { value: 'Y', label: this.$t("erp.global.yes", { defaultValue: '是' }) },
                    { value: 'N', label: this.$t("erp.global.no", { defaultValue: '否' }) },
                ]
            },
            shapeTypeList(){
                return[
                    { value: '0', label: this.$t('erp.product.cuboid', { defaultValue: '长方体' }) },
                    { value: '1', label: this.$t('erp.product.differentform', { defaultValue: '异形体' }) },
                ]
            },
            materialTypeList(){
                return [
                    { value: '0', label: this.$t('erp.product.cartons', { defaultValue: '纸箱' }) },
                    { value: '1', label: this.$t('bi.work.task_category_other', { defaultValue: '其他' }) },
                ]
            },
            propsData(){
                return [
                    {label:this.$t('global.common.line',{defaultValue:'项目'}),key:'IN_lineId',tag:'Select',value:this.productTarget,props:'multiple'},
                    {label:'ERPSKU',key:'CN_erpSku'},
                    {label:this.$t('erp.product.category',{defaultValue:'品类'}),key:'EQ_categoryCode',tag:'vSelect',value:this.categoryList},
                    {label:this.$t('erp.product.pruchas_status',{defaultValue:'补货状态'}),key:'EQ_status',tag:'Select',value:this.replenList},
                    // {label:this.$t('erp.product.product_status',{defaultValue:'产品状态'}),key:'EQ_enable',tag:'Select',value:this.isUsed},
                    {label:this.$t('erp.product.category_name',{defaultValue:'品名'}),key:'CN_name'},
                    {label:this.$t('erp.product.is_seasonal',{defaultValue:'是否季节性'}),key:'EQ_isSeasonal',tag:'Select',value:this.isSeasonal},
                    {label:this.$t('erp.product.product_type',{defaultValue:'产品类型'}),key:'EQ_productType',tag:'Select',value:this.peoductsType},
                    {label:this.$t('erp.product.repack_ornot',{defaultValue:'运输包装方式'}),key:'EQ_packingType',tag:'Select',value:this.packingTypeList},
                    {label:this.$t('erp.product.signature',{defaultValue:'签收服务'}),key:'EQ_isSignService',tag:'Select',value:this.isSeasonal},
                    {label:this.$t('erp.product.express_valuation',{defaultValue:'快递保价'}),key:'EQ_isInsurance',tag:'Select',value:this.isInsuranceList},
                    {label:this.$t('global.common.update_time',{defaultValue:'更新时间'}),key:['GE_updatedAt','LE_updatedAt'],tag:'timearray'},
                    {label:this.$t('erp.product.saleslocation',{defaultValue:'销售定位'}),key:'IN_saleLocation',tag:'Select',value:this.saleLocationList,props:'multiple'},
                    {label:this.$t('erp.product.label',{defaultValue:'标签'}),key:'IN_productLabel',tag:'Select',value:this.iconList,props:'multiple'},
                    {label:this.$t('erp.product.allow_distribution',{defaultValue:'是否允许分销'}),key:'EQ_isDistribution',tag:'Select',value:this.isDistributionList},
                    {label:'UPC',key:'EQ_upc'},
                    {label:this.$t('erp.product.out_box_shape', { defaultValue: '单品包装形状' }),key:'EQ_shapeType',tag:'Select',value:this.shapeTypeList},
                    {label:this.$t('erp.product.out_box_material', { defaultValue: '单品包装材质' }),key:'EQ_materialType',tag:'Select',value:this.materialTypeList},
                    {label:this.$t('erp.product.ismagnetic', { defaultValue: '是否带磁' }),key:'EQ_isMagnetism',tag:'Select',value:this.isSeasonal},
                    {label:this.$t('erp.product.isliquid', { defaultValue: '是否含液体' }),key:'EQ_isLiquid',tag:'Select',value:this.isSeasonal},
                    {label:this.$t('erp.product.isbattery', { defaultValue: '是否含电池' }),key:'EQ_isContainBattery',tag:'Select',value:this.isSeasonal},
                    {label:this.$t('erp.product.isfragile', { defaultValue: '是否易碎' }),key:'EQ_isFragile',tag:'Select',value:this.isSeasonal},

                ]
            },
            
        },
        methods: {
            handleErpSku (row) {
                this.$set(this.formData, 'CN_erpSku', row.erpSku);
            },
            getcategory(){
                HttpGetCategories().then(res=>{

                    res.data.map(item=>{
                        if(item.level == 3){
                            let data = {
                                label:item.name+' '+item.code,
                                value:item.code
                            }
                            this.categoryList.push(data)
                        }
                    })
                },err=>{
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
                })
                 // 获取增加标签的下拉列表
                HttpGetIconList().then(res=>{
                    this.iconList = res.data.map(item=>{
                        return {
                            label:item.labelName,
                            value:item.id,
                            labelColour:item.labelColour
                        }
                    })
                    console.log(res.data)
                },err=>{
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
                })
            },
            handleBtn(key,val,index){
                // console.log(key,val)
                this.changestatus = val;
                this.changekeys = key;

                this.getdate1 = []
                this.getdate2 = []
                this.$set(this.formData,key,val);
                this.update()
                // this.formData

            },
            handleModal(type,id) {
                // console.log(type,id)
                this.$parent.handleOperates('',type,id)
            },

            handleChange(date){
                this.formData.GE_updatedAt = date[0]
                this.formData.LE_updatedAt = date[1]
            },
            update(type,parms){
                // console.log(1111)
                const formdata = { ...this.formData };
                this.getdate = [this.formData.GE_updatedAt,this.formData.LE_updatedAt];
                this.$emit('on-update', { search: formdata, page: 1 });
               
            },
            resetdata(){
                
                this.formData = {
                    CN_erpSku: '',
                    EQ_sellersku: '',
                    EQ_accountId: '',
                    IN_lineId: '',
                    EQ_orgWarehouseId: '',
                    BT_beginDate: '',
                    EQ_status: null,
                    EQ_enable:'',
                    CN_name:'',
                    EQ_isSeasonal:'',
                    EQ_productType:'',
                    IN_saleLocation:'',
                    IN_productLabel:'',
                    EQ_isDistribution:'',
                    EQ_upc:'',
                    EQ_keyword: '',
                    EQ_shapeType: '',
                    EQ_materialType: '',
                    EQ_isMagnetism: '',
                    EQ_isLiquid: '',
                    EQ_isContainBattery: '',
                    EQ_isFragile: '',
                    GE_updatedAt:'',
                    LE_updatedAt:''
                };
                this.getdate = [this.formData.GE_updatedAt,this.formData.LE_updatedAt];
                this.$emit('on-update', {
                    search: {
                        ...this.formData
                    },
                    page: 1
                });
            },
            exportXlsx(type){
                // console.log(2222)
                // 查询条件导出
                // if (sessionStorage.get("downloadTotal") > 2000) {
                //     this.$Message.error("请导出2000条以内的数据");
                // } else {
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v1/Product/export", {
                        exportType:type,
                        "search[IN_lineId]": this.formData.IN_lineId ? this.formData.IN_lineId : '',
                        "search[CN_erpSku]": this.formData.CN_erpSku ? this.formData.CN_erpSku : '',
                        "search[EQ_categoryCode]": this.formData.EQ_categoryCode ? this.formData.EQ_categoryCode : '',

                        "search[EQ_status]": this.formData.EQ_status ? this.formData.EQ_status : '',
                        "search[EQ_enable]": this.formData.EQ_enable ? this.formData.EQ_enable : '',
                        "search[CN_name]": this.formData.CN_name ? this.formData.CN_name : '',
                        "search[EQ_isSeasonal]": this.formData.EQ_isSeasonal ? this.formData.EQ_isSeasonal : '',
                        "search[EQ_productType]": this.formData.EQ_productType ? this.formData.EQ_productType : '',
                        
                        "search[IN_saleLocation]": this.formData.IN_saleLocation ? this.formData.IN_saleLocation : '',
                        "search[IN_productLabel]": this.formData.IN_productLabel ? this.formData.IN_productLabel : '',
                        "search[EQ_isDistribution]": this.formData.EQ_isDistribution ? this.formData.EQ_isDistribution : '',
                        "search[EQ_upc]": this.formData.EQ_upc ? this.formData.EQ_upc : '',
                        "search[EQ_shapeType]": this.formData.EQ_shapeType ? this.formData.EQ_shapeType: '',
                        "search[EQ_materialType]": this.formData.EQ_materialType ? this.formData.EQ_materialType: '',
                        "search[EQ_isMagnetism]": this.formData.EQ_isMagnetism ? this.formData.EQ_isMagnetism: '',
                        "search[EQ_isFragile]": this.formData.EQ_isFragile ? this.formData.EQ_isFragile: '',
                        "search[EQ_isContainBattery]": this.formData.EQ_isContainBattery ? this.formData.EQ_isContainBattery: '',
                        "search[EQ_isLiquid]": this.formData.EQ_isLiquid ? this.formData.EQ_isLiquid: '',
                        "search[GE_updatedAt]": this.formData.GE_updatedAt ? this.formData.GE_updatedAt : '',
                        "search[LE_updatedAt]": this.formData.LE_updatedAt ? this.formData.LE_updatedAt : '',

                    }, {
                        executor: 'request',
                        download: true,
                    }).catch(err => {
                        // this.$VMessage.error(err.message);
                    })
                // }
            },


        },
    };
</script>
